import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthVerifyService } from "../../_services/auth-verify.service";

@Injectable()
export class AuthVerifiedResolver implements Resolve<any> {
  constructor(private authVerifyService: AuthVerifyService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> {
    this.authVerifyService.verified();
    return this.authVerifyService.verifiedObs();
  }
}
